<template>
  <div>
    <Overview :explorerInfo="explorerInfo" />
    <div class="d-flex mt-2 justify-sb xs-wrap">
      <div class="col-8 col-xs-12">
        <div class="card">
          <div class="card-tltle">
            <img src="@/assets/image/book.png" />{{ $t("user.mine.wallet") }}
          </div>
          <div class="card-body">
            <p class="detail">
              <strong>{{ $t("user.mine.address") }}: </strong>
              <span
                class="copy"
                v-clipboard="wallets.address"
                v-clipboard:success="clipboardSuccessHandler"
                v-clipboard:error="clipboardErrorHandler"
                >{{ wallets.address }}</span
              >
            </p>
            <p class="detail">
              <strong>{{ $t("user.mine.balance") }}: </strong
              ><span class="val">{{ balance.available || 0 }}</span>
              <strong> MASS</strong>
              &nbsp; &nbsp; &nbsp;
              <span class="grey" v-if="balance.all != balance.available">
                <strong>{{ $t("user.mine.balance_frozen") }}:</strong>
                {{ balance.all - balance.available }}
                <strong> MASS</strong></span
              >
            </p>
            <p class="detail">
              <strong>{{ $t("user.mine.activationQuota") }}: </strong
              ><span class="val">{{ balance.binding || 0 }}</span>
              <strong> MASS</strong>
            </p>
          </div>
        </div>
      </div>
      <div class="col-4 col-xs-12">
        <div class="card xs-noCard" style="height: 100%;">
          <div class="card-tltle">
            <img src="@/assets/image/book.png" />{{ $t("user.mine.tranfer") }}
          </div>
          <div class="card-body d-flex xs-column">
            <button class="btn btn-blue mr-3 col-xs-12" @click="showTransIn">
              {{ $t("user.mine.tranerIn") }}
            </button>
            <button class="btn btn-blue white col-xs-12" @click="showTransOut">
              {{ $t("user.mine.tranerOut") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import { TransferOut, TransferIn, Overview } from "./components";
import { Password } from "@/components";
export default {
  name: "home",
  meta: {
    authorization: true,
  },
  components: {
    Overview,
  },
  computed: {
    ...mapState("wallet", ["balance", "wallets"]),
  },
  filters: {
    formatTime(val) {
      const zone = 8 * 60 * 60 * 1000;
      return moment(new Date(val + zone)).format("YYYY-MM-DD HH:mm");
    },
    trans(val) {
      return val >= 0 ? val : "-";
    },
  },
  data() {
    return {
      tradeInfo: {},
      explorerInfo: {},
    };
  },
  methods: {
    ...mapActions("wallet", [
      "getWallets",
      "getBalance",
      "refrushWallet",
      "sendTransaction",
    ]),
    ...mapActions("home", ["getExplorerLastInfo"]),
    ...mapActions("user", ["walletLogin"]),
    clipboardSuccessHandler() {
      this.$tooltip.success(this.$t("home.components.transIn.success"));
    },
    clipboardErrorHandler() {
      this.$tooltip.success(this.$t("home.components.transIn.fail"));
    },
    showTransOut() {
      this.$modal.show({
        component: <TransferOut vOn:showPassword={this.showPassword} />,
        close: () => {
          console.log("close");
        },
      });
    },
    showPassword(params) {
      this.tradeInfo = params;
      this.$modal.show({
        component: <Password vOn:submit={this.createTrade} />,
        close: () => {},
      });
    },
    async createTrade(passphrase) {
      this.tradeInfo.passphrase = passphrase;
      try {
        await this.sendTransaction(this.tradeInfo);
        this.$tooltip.success(this.$t("home.components.transOut.success"));
        this.refrushWallet();
        this.$modal.close();
      } catch (e) {
        console.log(e);
      }
    },
    showTransIn() {
      this.$modal.show({
        component: <TransferIn />,
        close: () => {
          console.log("close");
        },
      });
    },
  },
  async mounted() {
    try {
      await this.getWallets();
    } catch (e) {
      this.$router.push({ name: "createWallet" });
    }
    this.getBalance();
    const res = await this.getExplorerLastInfo();
    this.explorerInfo = res.data;
  },
};
</script>
<style lang="scss" scoped>
.copy {
  cursor: pointer;
  text-decoration: underline;
}
.detail {
  font-size: 14px;
  color: #080807;
  line-height: 14px;
  margin-top: 20px;
  .val {
    font-size: 14px;
    font-weight: 400;
    color: var(--main-color);
    line-height: 14px;
  }
}

.mt-2 {
  margin-top: 20px;
}
.d-flex{
  display: block;
}

@media screen and (min-width: 770px) {
  .d-flex{
    display: flex;
  }

  .col-8 {
    flex: 0.7;
  }
  .col-4 {
    margin-left: 32px;
    flex: 0.3;
  }
}

.btn {
  font-size: 12px;
  font-weight: bold;
  color: #ffffff;
  line-height: 17px;
  padding: 8px 63px;
  white-space: nowrap;
  margin-top: 2rem;
}
.btn.white {
  background: #ffffff;
  border: 1px solid #e5e5e5;
  color: #838383;
}
.mr-3 {
  margin-right: 30px;
}
@media screen and (max-width: 768px) {
  .col-xs-12 {
    flex: 1;
    width: 100%;
    margin-left: 0;
    .detail {
      line-height: 1.5;
      display: flex;
      strong {
        width: 70px;
        flex-shrink: 0;
      }
      strong:lang(en):first-child {
        width: 125px;
        text-align: right;
        margin-right: 10px;
      }
      .val {
        line-height: inherit;
        margin-right: 5px;
      }
    }
  }
  .xs-wrap {
    flex-wrap: wrap;
  }
  .xs-column{
    flex-direction: column;
  }
  .copy {
    word-break: break-all;
  }
  .xs-noCard{

    padding-bottom: 50px;
    .card-tltle{
      display: none;
    }
  }
  .btn {
    padding-top: 14px;
    padding-bottom: 14px;
    font-size: 16px;
    line-height: 22px;
    margin-right: 0;
  }
}
</style>
